import { get, post, type RequestOptions } from '@/api/client';
import type {
  CostOfDelayResponse,
  PatientSignals,
  TpiCheatsheet,
  TpiSubstrate,
  TpiTreatments,
  TreatmentPlanAsyncJob,
  TreatmentPlanLink,
} from './types';

export const tpiApi = {
  getCheatsheet: (patientId: number, options?: RequestOptions) =>
    get<TpiCheatsheet>(`/api/tpi/patients/${patientId}/tc-cheatsheet`, undefined, options),

  getSubstrate: (patientId: number) =>
    get<TpiSubstrate>(`/api/tpi/patients/${patientId}/substrate`),

  getTreatments: (patientId: number, options?: RequestOptions) =>
    get<TpiTreatments>(`/api/tpi/patients/${patientId}/treatments`, undefined, options),

  getSignals: (patientId: number) =>
    get<PatientSignals>(`/api/patients/${patientId}/signals`),

  getCostOfDelay: () =>
    get<CostOfDelayResponse>('/api/tpi/cost-of-delay'),

  getUrgencyLink: (patientId: number) =>
    get<{ link: string }>(`/api/tpi/patients/${patientId}/urgency-link`),

  getTreatmentPlanLink: (patientId: number, options?: RequestOptions) =>
    get<TreatmentPlanLink>(
      `/api/tpi/patients/${patientId}/treatment-plan-link`,
      undefined,
      options,
    ),

  createTreatmentPlanAsync: (patientId: number) =>
    post<TreatmentPlanAsyncJob>(`/api/tpi/patients/${patientId}/treatment-plan-async`),

  pollTreatmentPlanJob: (jobId: string, options?: RequestOptions) =>
    get<TreatmentPlanAsyncJob>(`/api/tpi/treatment-plan-async/${jobId}`, undefined, options),

  invalidateVisitCache: (patientId: number) =>
    post<void>(`/api/tpi/patients/${patientId}/visit-cache/invalidate`),
};
